import config from 'src/config';
import axios from 'axios';

export interface VersionDto {
    systemId: string;
    systemVersion: string;
    releasedAt: string;
    revisionReason: string;
    remark: string;
}

export const getVersion = async (): Promise<VersionDto | null> => {
    try {
        const res = await axios.get(`${config.apiUrl}/version/first`);
        return res.data?.data ?? null;
    } catch {
        return null;
    }
};
